import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { TranslatePipe } from '@shared/pipes/translate.pipe';

@Component({
    selector: 'app-internal-server-error-page',
    imports: [CommonModule, SharedModule, TranslatePipe],
    templateUrl: './internal-server-error-page.component.html',
    styleUrl: './internal-server-error-page.component.scss'
})
export class InternalServerErrorPageComponent {

  constructor(private router: Router) {}

  goToHome(): void {
    this.router.navigate(['/home']);
  }
}
